module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CheckInSuccessView.js"));
	}, "CheckInSuccessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CheckInSuccessView!./src/pages/Promote/OfflineActivity/CheckIn/CheckInSuccess/CheckInSuccessView.js
// module id = 2113
// module chunks = 367